import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-钻井分析_复杂故障统计",
  "use": "icon-钻井分析_复杂故障统计-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-钻井分析_复杂故障统计\">\n<g>\n\t<g>\n\t\t<path d=\"M8,3.3l6.4,10.4H1.6L8,3.3 M8,1.3L0.2,13.9c-0.2,0.3,0.1,0.8,0.4,0.8h14.6c0.4,0,0.6-0.4,0.4-0.8L8,1.3L8,1.3z\" />\n\t</g>\n\t<g>\n\t\t<rect x=\"7.5\" y=\"6.2\" width=\"1\" height=\"5.2\" />\n\t</g>\n\t<g>\n\t\t<rect x=\"7.5\" y=\"11.9\" width=\"1\" height=\"1\" />\n\t</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol